import { motion } from "framer-motion";
import { Swords, Target, Heart, Brain, AudioLines, BarChart3 } from "lucide-react";

const features = [
  {
    icon: Swords,
    title: "Competition",
    description: "Rehearse high-pressure moments and build unshakable confidence before game day.",
  },
  {
    icon: Target,
    title: "Practice",
    description: "Accelerate skill acquisition and boost training consistency through mental reps.",
  },
  {
    icon: Heart,
    title: "Recovery",
    description: "Support emotional resilience, heal from setbacks, and return to play with clarity.",
  },
  {
    icon: Brain,
    title: "Fully Personalized",
    description: "Every visualization is built from your sport, goals, experience, and real-time inputs.",
  },
  {
    icon: AudioLines,
    title: "Premium Audio",
    description: "Choose your voice, hit play, and immerse yourself in a guided session designed just for you.",
  },
  {
    icon: BarChart3,
    title: "Track Progress",
    description: "Monitor streaks, sessions, and mental performance lift to see your growth over time.",
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const FeaturesSection = () => {
  return (
    <section className="py-24 md:py-32 bg-secondary/30" id="features">
      <div className="container px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <motion.h2
            className="font-display text-3xl md:text-5xl font-bold mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Train your mind like you train your{" "}
            <span className="text-gradient-primary">body</span>
          </motion.h2>
          <motion.p
            className="text-muted-foreground text-lg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            Three visualization modes. One powerful engine. Built around you.
          </motion.p>
        </div>

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {features.map((f) => (
            <motion.div
              key={f.title}
              variants={item}
              className="group gradient-card rounded-xl p-6 border border-border/50 hover:border-primary/30 transition-all duration-300 shadow-card"
            >
              <div className="w-12 h-12 rounded-lg gradient-cta flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <f.icon className="w-6 h-6 text-primary-foreground" />
              </div>
              <h3 className="font-display text-xl font-semibold mb-2">{f.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{f.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
